import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect, useSelector } from 'react-redux';
import isEmpty from 'lodash/isEmpty';

import { selectWidthMQ } from 'core/modules/MediaQueries/selectors';

import { hideIncompleteRow } from 'core/utils/helpers/hideIncompleteRow';
import MerchantTileListItem from './components/MerchantTileListItem/MerchantTileListItem';

import { selectMerchantTileListConfig } from './selectors';

import './MerchantTileList.scss';

function MerchantTileList({
  merchants, tileItem, useSmallerIcon, label, shouldHideIncompleteRow, children, useAddToFavorite, trackingParams,
}) {
  const merchantTileListRef = useRef();
  const widthMQ = useSelector(selectWidthMQ);

  useEffect(() => {
    if (shouldHideIncompleteRow) {
      hideIncompleteRow(merchantTileListRef.current);
    }
  }, [merchantTileListRef.current, widthMQ]);

  if (isEmpty(merchants)) {
    return false;
  }
  const TileItem = tileItem || MerchantTileListItem;

  return (
    <div className="mn_merchantTileList" ref={merchantTileListRef}>
      {merchants.map(merchant => (
        <TileItem
          key={merchant.id}
          merchant={merchant}
          label={label}
          useSmallerIcon={useSmallerIcon}
          useAddToFavorite={useAddToFavorite}
          trackingParams={trackingParams}
        />
      ))}
      {children}
    </div>
  );
}

MerchantTileList.propTypes = {
  merchants: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  useAddToFavorite: PropTypes.bool,
  config: PropTypes.shape({}),
  tileItem: PropTypes.node,
};

MerchantTileList.defaultProps = {
  useAddToFavorite: true,
  config: {},
  tileItem: null,
};

const mapStateToProps = state => ({
  config: selectMerchantTileListConfig(state),
});

export default connect(mapStateToProps)(MerchantTileList);
